import SsoClient, { SsoClientConf, SsoOptions } from 'telia-sso-client';

export class SsoClientService {
  public ssoClientInstance: SsoClient;

  public get client(): SsoClient {
    return this.ssoClientInstance;
  }

  public init(conf: SsoClientConf, options: SsoOptions): void {
    this.ssoClientInstance = SsoClient.connect(conf, options);
  }

  public doLogout(): void {
    this.ssoClientInstance.doLogout();
  }

  public loadInitialState(): void {
    this.ssoClientInstance.loadInitialState();
  }

  public setLocale(locale: 'et' | 'ru'): void {
    this.ssoClientInstance.setOptions({ locale: locale });
  }

  public setAuthLevel(authLevel: number): void {
    this.ssoClientInstance.setOptions({ authLevel: authLevel });
  }

  public loginUrl(): string {
    return this.ssoClientInstance.getLoginUrl({ selectMandate: true });
  }
}
